"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACK_TYPER = void 0;
let TRACK_TYPER = exports.TRACK_TYPER = /*#__PURE__*/function (TRACK_TYPER) {
  TRACK_TYPER["PAGE_VIEW"] = "trackPageView";
  TRACK_TYPER["EVENT"] = "trackEvent";
  TRACK_TYPER["LINK"] = "trackLink";
  return TRACK_TYPER;
}({});